import { isToday, isYesterday } from 'date-fns';
import type { IntlShape } from 'react-intl';
import { formatContextLinkingSessionDateMessages } from './formatContextLinkingSessionDate.messages';

/**
 * Formats a session date in a human-readable way:
 * - "Today" if the date is today
 * - "Yesterday" if the date was yesterday
 * - locale-aware short date for dates in the current year
 * - locale-aware short date with year for dates in previous years
 */
export function formatSessionDate(dateString: string, intl: IntlShape): string {
  const date = new Date(dateString);
  if (isToday(date)) {
    return intl.formatMessage(formatContextLinkingSessionDateMessages.today);
  }
  if (isYesterday(date)) {
    return intl.formatMessage(formatContextLinkingSessionDateMessages.yesterday);
  }
  const currentYear = new Date().getFullYear();
  const dateYear = date.getFullYear();
  if (dateYear === currentYear) {
    return intl.formatDate(date, { month: 'short', day: 'numeric' });
  }
  return intl.formatDate(date, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
